"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function sc(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 5.625C13.6908 5.625 15.3123 6.29665 16.5078 7.49219C17.7034 8.68774 18.375 10.3092 18.375 12V18.375H12C10.3092 18.375 8.68774 17.7034 7.49219 16.5078C6.29665 15.3123 5.625 13.6908 5.625 12C5.625 10.3092 6.29665 8.68774 7.49219 7.49219C8.68774 6.29665 10.3092 5.625 12 5.625ZM15.825 15.825V12.0577C15.825 9.94275 14.1337 8.1855 12.0195 8.175C11.5141 8.17302 11.0133 8.2711 10.5459 8.4636C10.0786 8.65611 9.654 8.93921 9.29661 9.29661C8.93921 9.654 8.65611 10.0786 8.4636 10.5459C8.2711 11.0133 8.17302 11.5141 8.175 12.0195C8.1855 14.1337 9.9435 15.825 12.0577 15.825H15.825Z", fill: color }));
}
exports["default"] = sc;
//# sourceMappingURL=sc.js.map